module.exports = __webpack_public_path__ + "media/fonts/Unica77LLTT-Light--7caf3ff2e0b8457040ac1bb2c796a26e.eot";